"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const View = (props) => react_1.default.createElement(react_native_1.View, Object.assign({}, props));
exports.View = View;
exports.View.displayName = 'View';
